import { useEffect, useCallback } from 'react';

/**
 * Botão flutuante para abrir/fechar sidebar em mobile.
 * Adiciona/remover classe body.sidebar-open para controlar overlay.
 */
export default function MobileMenuButton() {
  const toggleSidebar = useCallback(() => {
    // Delegar ao AdminLTE (pushmenu) se disponível; caso contrário, alternar classe
    const pushMenuTrigger = document.querySelector('[data-widget="pushmenu"]') as HTMLElement | null;
    if (pushMenuTrigger) {
      pushMenuTrigger.click();
    } else {
      document.body.classList.toggle('sidebar-open');
    }
  }, []);

  // Fechar quando clicar no overlay
  useEffect(() => {
    let overlay: HTMLDivElement | null = document.querySelector('.sidebar-overlay') as HTMLDivElement;
    if (!overlay) {
      overlay = document.createElement('div');
      overlay.className = 'sidebar-overlay';
      document.body.appendChild(overlay);
    }
    const handleClick = () => {
      // Fechar via AdminLTE quando possível para manter estados consistentes
      const pushMenuTrigger = document.querySelector('[data-widget="pushmenu"]') as HTMLElement | null;
      if (pushMenuTrigger && document.body.classList.contains('sidebar-open')) {
        pushMenuTrigger.click();
      }
      document.body.classList.remove('sidebar-open');
    };
    overlay.addEventListener('click', handleClick);
    return () => overlay && overlay.removeEventListener('click', handleClick);
  }, []);

  // Fechar sidebar automaticamente ao clicar em qualquer link do menu (mobile)
  useEffect(() => {
    const links = Array.from(document.querySelectorAll('.main-sidebar .nav-link')) as HTMLElement[];
    const onNavClick = (e: Event) => {
      if (window.matchMedia('(max-width: 991.98px)').matches && document.body.classList.contains('sidebar-open')) {
        const target = e.currentTarget as HTMLElement | null;
        // EXCEÇÃO: manter aberto para menus que possuem submenu (ex: SophyGames)
        const parentItem = target?.closest('.nav-item.has-treeview');
        if (!parentItem) {
          const pushMenuTrigger = document.querySelector('[data-widget="pushmenu"]') as HTMLElement | null;
          if (pushMenuTrigger) pushMenuTrigger.click();
          document.body.classList.remove('sidebar-open');
        }
      }
    };
    links.forEach((el) => el.addEventListener('click', onNavClick));
    return () => links.forEach((el) => el.removeEventListener('click', onNavClick));
  }, []);

  return (
    <button
      type="button"
      aria-label="Abrir menu"
      className="mobile-menu-btn d-md-none"
      onClick={toggleSidebar}
    >
      <i className="fas fa-bars"></i>
    </button>
  );
}
